import { useState, useEffect } from 'react';
import api from '../services/api';
import Swal from 'sweetalert2';
import Select from 'react-select';

export default function ModalCobro({ items, total, onSuccess, onCancel, ordenId = null, esSeparada = false }) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [aplicaRetencion1, setAplicaRetencion1] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState('01');
  const [cash, setCash] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ NUEVO: correo de envío de la factura
  const [correoEnvio, setCorreoEnvio] = useState('');
  const [usarOtroCorreo, setUsarOtroCorreo] = useState(false);
  const [otroCorreo, setOtroCorreo] = useState('');
  const [guardarCorreo, setGuardarCorreo] = useState(false);
  const [referenciaCorreo, setReferenciaCorreo] = useState('');

  const resetCorreo = () => {
    setUsarOtroCorreo(false);
    setOtroCorreo('');
    setGuardarCorreo(false);
    setReferenciaCorreo('');
  };

  useEffect(() => {
    api.get('/clients').then(res => {
      const data = res.data.data ?? res.data;
      setClients(data);
      const varios = data.find(c => c.nombre.toUpperCase() === 'CLIENTES VARIOS');
      if (varios) {
        setSelectedClient({ value: varios.id, label: varios.nombre });
      }
    });
  }, []);

useEffect(() => {
  if (selectedClient) {
    const cliente = clients.find(c => c.id === selectedClient.value);
    if (cliente) {
      setTipoDocumento('01'); // 👈 Siempre Consumidor Final por defecto
    }
  }
}, [selectedClient, clients]);

    // ✅ NUEVO: al cambiar de cliente, poner su correo predeterminado
  useEffect(() => {
    const cliente = selectedClient ? clients.find(c => c.id === selectedClient.value) : null;
    const lista = cliente?.emails ?? [];
    const predeterminado = lista.find(e => e.is_default) ?? lista[0];
    setCorreoEnvio(predeterminado?.email ?? cliente?.email ?? '');
    resetCorreo();
  }, [selectedClient, clients]);

  const clienteFull = selectedClient ? clients.find(c => c.id === selectedClient.value) : null;
  const puedeElegirTipoFactura = clienteFull?.tipo_cliente === 'Contribuyente';
    const clientOptions = clients.map(c => {
    const lista = c.emails ?? [];
    const predeterminado = lista.find(e => e.is_default) ?? lista[0];
    return {
      value: c.id,
      label: c.nombre,
      detalle: predeterminado
        ? (predeterminado.referencia ? `${predeterminado.referencia} — ${predeterminado.email}` : predeterminado.email)
        : (c.email || ''),
      totalCorreos: lista.length,
      buscar: [c.nombre, ...lista.map(e => `${e.email} ${e.referencia ?? ''}`)].join(' ').toLowerCase(),
    };
  });

  // ✅ NUEVO: correos del cliente seleccionado
  const correosCliente = clienteFull?.emails?.length
    ? clienteFull.emails
    : (clienteFull?.email ? [{ email: clienteFull.email, referencia: null, is_default: true }] : []);
  const esClientesVarios = (clienteFull?.nombre || '').trim().toUpperCase() === 'CLIENTES VARIOS';

  const submitSale = async () => {
    if (!selectedClient) return Swal.fire('Error', 'Seleccione un cliente', 'warning');
    const montoACobrar = aplicaRetencion1 ? total - (total * 0.01 / 1.13) : total;
if (Number(cash) < montoACobrar) return Swal.fire('Error', 'Monto insuficiente', 'warning');
    if (tipoDocumento === '03' && clienteFull?.tipo_cliente !== 'Contribuyente') {
      return Swal.fire('Error', 'No se puede emitir Crédito Fiscal a un cliente No Contribuyente', 'error');
    }
        // ✅ NUEVO: validar el correo escrito a mano
    if (usarOtroCorreo && otroCorreo.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(otroCorreo.trim())) {
      return Swal.fire('Error', 'El correo escrito no es válido', 'warning');
    }
    if (isSubmitting) return;
    setIsSubmitting(true);

try {
      const cashAmount = parseFloat(cash) || 0;
      const clienteData = clients.find(c => c.id === Number(selectedClient.value));

      const details = items.map(item => ({
        product_id: Number(item.product_id),
        presentation_id: item.presentation_id || null,
        cantidad: Number(item.cantidad) || 1,
        precio_unitario: Number(item.precio_unitario) || 0,
      }));

      // IDs reales de los orden_items que se están cobrando ahora,
      // para que el backend los elimine de la orden activa
      const ordenItemIds = items
        .map(item => {
          const partes = item.uniqueKey?.split('-');
          return partes ? Number(partes[partes.length - 1]) : null;
        })
        .filter(id => id && !isNaN(id));

      const fechaMySQL = new Date().toISOString().slice(0, 19).replace('T', ' ');

      const payload = {
        client_id: Number(selectedClient.value),
        tipo_cliente: clienteData.tipo_cliente.toLowerCase().replace(' ', '_'),
        fecha_venta: fechaMySQL,
        details,
        subtotal: total,
        total_gravado: total,
        total_exento: 0,
        iva_total: 0,
        monto_final: total,
        condicion_operacion: 'CONTADO',
        estado: 'PENDIENTE',
        cash: cashAmount,
        change: cashAmount - total,
        tipo_documento: tipoDocumento,
        aplica_retencion_1: aplicaRetencion1,
        aplica_retencion_1: aplicaRetencion1,
        orden_id: ordenId || null,
        orden_item_ids: ordenItemIds,
      };

      // ✅ NUEVO: correo al que se enviará la factura
      const correoFinal = usarOtroCorreo ? otroCorreo.trim() : correoEnvio;
      if (correoFinal) payload.correo_envio = correoFinal;
      if (usarOtroCorreo && guardarCorreo && correoFinal) {
        payload.guardar_correo = true;
        payload.referencia_correo = referenciaCorreo.trim() || null;
      }

      const saleRes = await api.post('/sales', payload);
      const saleData = saleRes.data.data;

      // La orden se cierra automáticamente en el backend cuando ya no quedan
      // items pendientes (ver SaleController@store), así que ya no hace falta
      // llamar a /ordenes/{id}/cerrar desde aquí.

      onSuccess({
        ...saleData,
        cash: payload.cash,
        change: payload.change,
      });

      setCash('');
    } catch (error) {
      Swal.fire('Error', error.response?.data?.message || 'Error al facturar', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content card">
            <div className="card-header">
              <h3 className="card-title" style={{ margin: 0 }}>💰 Cobro</h3>
              <button className="btn btn-secondary btn-sm" onClick={onCancel}>✕</button>
            </div>

            <div className="card-body">
              <div className="form-group mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>Cliente</label>
                <Select
                  options={clientOptions}
                  value={selectedClient}
                  onChange={setSelectedClient}
                  placeholder="Seleccionar cliente..."
                  filterOption={(opt, input) =>
                    (opt.data.buscar || opt.label.toLowerCase()).includes(input.toLowerCase())
                  }
                  formatOptionLabel={(opt, { context }) =>
                    context === 'menu' && opt.detalle ? (
                      <div>
                        <div>{opt.label}</div>
                        <small style={{ color: '#718096' }}>
                          {opt.detalle}
                          {opt.totalCorreos > 1 ? ` · ${opt.totalCorreos} correos` : ''}
                        </small>
                      </div>
                    ) : opt.label
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#e2e8f0',
                      borderWidth: '2px',
                      borderRadius: '10px',
                      padding: '4px',
                      '&:hover': { borderColor: '#667eea' }
                    })
                  }}
                />
              </div>

                            {/* ✅ NUEVO: correo de envío */}
              {clienteFull && (
                <div className="form-group mb-3">
                  <label className="form-label" style={{ fontWeight: 600 }}>📧 Enviar factura a</label>

                  {!usarOtroCorreo ? (
                    <select
                      className="form-control"
                      value={correoEnvio}
                      onChange={e => {
                        if (e.target.value === '__otro__') {
                          setUsarOtroCorreo(true);
                        } else {
                          setCorreoEnvio(e.target.value);
                        }
                      }}
                      style={{ fontSize: '15px' }}
                    >
                      {correosCliente.length === 0 && (
                        <option value="">Sin correo (no se enviará)</option>
                      )}
                      {correosCliente.map(c => (
                        <option key={c.email} value={c.email}>
                          {c.is_default ? '⭐ ' : ''}
                          {c.referencia ? `${c.referencia} — ${c.email}` : c.email}
                        </option>
                      ))}
                      <option value="__otro__">➕ Escribir otro correo…</option>
                    </select>
                  ) : (
                    <div style={{ padding: '12px', background: '#f7fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                      <input
                        type="email"
                        className="form-control mb-2"
                        placeholder="correo@ejemplo.com"
                        value={otroCorreo}
                        onChange={e => setOtroCorreo(e.target.value)}
                      />

                      {!esClientesVarios && (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                              type="checkbox"
                              id="guardarCorreo"
                              checked={guardarCorreo}
                              onChange={e => setGuardarCorreo(e.target.checked)}
                              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <label htmlFor="guardarCorreo" style={{ margin: 0, cursor: 'pointer' }}>
                              Guardar en este cliente
                            </label>
                          </div>
                          {guardarCorreo && (
                            <input
                              type="text"
                              className="form-control mt-2"
                              placeholder="Referencia (ej. Edwin González)"
                              value={referenciaCorreo}
                              onChange={e => setReferenciaCorreo(e.target.value)}
                            />
                          )}
                        </>
                      )}

                      <button
                        type="button"
                        className="btn btn-secondary btn-sm mt-2"
                        onClick={resetCorreo}
                      >
                        ← Volver a la lista
                      </button>
                    </div>
                  )}
                </div>
              )}

              <div className="form-group mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>Tipo de Factura</label>
                {!puedeElegirTipoFactura ? (
                  <div style={{ padding: '12px', background: '#f0f9ff', borderRadius: '8px', border: '2px solid #0ea5e9' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input type="radio" checked disabled />
                      <span style={{ fontWeight: 600 }}>📄 Consumidor Final</span>
                    </div>
                    <small style={{ color: '#0369a1', display: 'block', marginTop: '4px' }}>
                      Este cliente solo puede recibir factura de consumidor final
                    </small>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div
                      onClick={() => setTipoDocumento('01')}
                      style={{ padding: '12px', background: tipoDocumento === '01' ? '#f0f9ff' : '#f7fafc', border: tipoDocumento === '01' ? '2px solid #0ea5e9' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="radio" checked={tipoDocumento === '01'} onChange={() => setTipoDocumento('01')} />
                        <span style={{ fontWeight: 600 }}>📄 Consumidor Final</span>
                      </div>
                    </div>
                    <div
                      onClick={() => setTipoDocumento('03')}
                      style={{ padding: '12px', background: tipoDocumento === '03' ? '#f0fdf4' : '#f7fafc', border: tipoDocumento === '03' ? '2px solid #10b981' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="radio" checked={tipoDocumento === '03'} onChange={() => setTipoDocumento('03')} />
                        <span style={{ fontWeight: 600 }}>💼 Crédito Fiscal</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Checkbox Retención 1% - Visible para ambos tipos */}
<div className="form-group mb-3" style={{
  padding: '12px',
  background: '#fffbeb',
  borderRadius: '8px',
  border: '1px solid #f59e0b'
}}>
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <input
      type="checkbox"
      id="aplicaRetencion"
      checked={aplicaRetencion1}
      onChange={e => setAplicaRetencion1(e.target.checked)}
      style={{ width: '18px', height: '18px', cursor: 'pointer' }}
    />
    <label htmlFor="aplicaRetencion" style={{ cursor: 'pointer', fontWeight: 600, margin: 0 }}>
      Aplicar Retención 1% IVA
    </label>
  </div>
  {aplicaRetencion1 && (
  <small style={{ color: '#92400e', display: 'block', marginTop: '6px' }}>
                Retención: ${(total * 0.01 / 1.13).toFixed(4)} — 
                Neto a cobrar: ${(total - (total * 0.01 / 1.13)).toFixed(2)}
              </small>
  )}
</div>

<div className="alert alert-success" style={{ color: '#000', fontSize: '22px' }}>
  <strong>Total a pagar:</strong> ${aplicaRetencion1
    ? (total - (total * 0.01 / 1.13)).toFixed(2)
    : total.toFixed(2)}
</div>

              <div className="form-group">
                <label className="form-label">Monto Recibido</label>
                <input
                  type="text"
                  inputMode="decimal"
                  className="form-control"
                  placeholder="0.00"
                  value={cash}
                  autoFocus
                  onChange={e => {
                    const value = e.target.value;
                    if (value === '' || /^\d*\.?\d*$/.test(value)) setCash(value);
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (cash && Number(cash) >= total && !isSubmitting) submitSale();
                    }
                  }}
                  style={{ fontSize: '18px', fontWeight: '600' }}
                />
              </div>

              {cash !== '' && (
                <div className={`alert ${
  Number(cash) >= (aplicaRetencion1 ? total - (total * 0.01 / 1.13) : total)
    ? "alert-success"
    : "alert-danger"
} mt-3`} style={{ color: '#000', fontSize: '22px' }}>
  <strong>
    {Number(cash) >= (aplicaRetencion1 ? total - (total * 0.01 / 1.13) : total)
      ? `✓ Vuelto: $${(Number(cash) - (aplicaRetencion1 ? total - (total * 0.01 / 1.13) : total)).toFixed(2)}`
      : "⚠ Monto insuficiente"}
  </strong>
</div>
              )}
            </div>

            <div className="card-body" style={{ borderTop: '2px solid #e2e8f0', display: 'flex', gap: '12px', paddingTop: '16px' }}>
              <button className="btn btn-secondary" onClick={onCancel} style={{ flex: 1 }}>
                Cancelar
              </button>
              <button
                className="btn btn-success"
                disabled={!cash || Number(cash) < (aplicaRetencion1 ? total - (total * 0.01 / 1.13) : total) || isSubmitting}
                onClick={submitSale}
                style={{ flex: 1 }}
              >
                {isSubmitting ? (
                  <><span className="spinner-border spinner-border-sm me-2" />Procesando...</>
                ) : '✓ Facturar'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}